// JsFromRoutes CacheKey 13051c007fae17ee803bce5f4fafbab3
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/interests/search'),
  popular: /* #__PURE__ */ definePathHelper('get', '/interests/popular'),
  random: /* #__PURE__ */ definePathHelper('get', '/interests/random'),
  bannedWords: /* #__PURE__ */ definePathHelper('get', '/interests/banned_words'),
}
